module.exports = __webpack_public_path__ + "img/opdracht-dictee.2ee883dc.png";